// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__18ARt","box":"WorkspacesBox_box__2hrs7","node":"WorkspacesBox_node__35qe2"};